/**
 * Lane C0-OUTFIT2X (user 2026-10-10, "จัดเต็ม"): outfits, hair and the starter pair drawn natively at the figure grid
 * (two canvas pixels per art pixel) with full detail, the man and the woman told apart, and part shading that takes
 * the light's side on the left-facing views. Off brings back the game as it was (Scale2x of art-pixel parts).
 */
export const OUTFIT2X = true;

let on: boolean = OUTFIT2X;

/** Whether figures are drawn the OUTFIT2X way on this page. */
export const outfit2x = (): boolean => on;

/** For review tools only: draw the before (false) or after (true) look on this page. */
export function setOutfit2x(v: boolean): void {
  on = v;
}
